var map = {
	"./Close-2.JPG": 180,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (1).jpeg": 181,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (12).jpeg": 182,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (14).jpeg": 183,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (15).jpeg": 184,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (16).jpeg": 185,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (20).jpeg": 186,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (21).jpeg": 187,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (3).jpeg": 188,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (6).jpeg": 189,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (9).jpeg": 190,
	"./WhatsApp Image 2021-02-23 at 22.49.29.jpeg": 191,
	"./_Collage.png": 192,
	"./why-3_.jpg": 193
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 179;